import React from 'react';

export default function ViewChange(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={24}
      {...props}
    >
      <defs>
        <path
          id="a"
          d="M15.156 2.844H18v1.867h-2.844v2.845h-1.867V4.71h-2.845V2.844h2.845V0h1.867v2.844zM13.289 16.09V10.4h1.867V18H0V2.844h7.6v1.867H1.911V16.09H13.29z"
        />
      </defs>
      <use xlinkHref="#a" fillRule="evenodd" transform="translate(4 2)" />
    </svg>
  );
}
